module.exports = __webpack_public_path__ + "img/edit.28563985.svg";